<template>
  <div class="product-price-group-detail-view">
    <dx-responsive-box>
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-col />
      <dx-col screen="md lg" />

      <dx-item>
        <dx-location :row="0" :col="0" />
        <div class="detail-element-container">
          Navn:
          <dx-textbox
            :value="row.data.name"
            :read-only="true"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="1" :col="0" />
        <dx-location screen="xs sm" :row="1" :col="0" />
        <div class="detail-element-container">
          Servicenummer:
          <dx-textbox
            :value="row.data.number"
            :read-only="true"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="2" :col="0" />
        <dx-location screen="xs sm" :row="2" :col="0" />
        <div class="detail-element-container padding-top">
          <dx-checkbox
            :value="row.data.internal"
            :read-only="true"
            text="Intern service"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="3" :col="0" />
        <dx-location screen="xs sm" :row="3" :col="0" />
        <div class="detail-element-container">
          <dx-checkbox
            :value="row.data.definesVolumeBasedPrices"
            :read-only="true"
            text="Har pristrappe"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="4" :col="0" />
        <dx-location screen="xs sm" :row="4" :col="0" />
        <div class="detail-element-container">
          <dx-checkbox
            :value="row.data.volumeBasedPricesIndexed"
            :read-only="true"
            text="Trappen prisindeksreguleres"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="5" :col="0" />
        <dx-location screen="xs sm" :row="5" :col="0" />
        <div class="detail-element-container">
          <dx-checkbox
            :value="row.data.volumeBasedPricesTier"
            :read-only="true"
            text="Trappen er en tier-trappe"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="0" :col="1" :rowspan="5" />
        <dx-location screen="xs sm" :row="5" :col="0" />
        <div>
          <div class="action-button-wrapper">
            <dx-button icon="edit" text="Rediger" @click="$emit('onEditClick', row)" :disabled="pricePeriod.active" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="hierarchy" text="Pristrappe" @click="$emit('onVolumebasedPriceClick', row)" :visible="row.data.definesVolumeBasedPrices" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="trash" text="Slet" @click="$emit('onDeleteClick', row)" :disabled="pricePeriod.active" class="action-button" />
          </div>
        </div>
      </dx-item>
    </dx-responsive-box>
  </div>
</template>

<script>
export default {
  name: 'DetailView',
  props: {
    row: Object,
    pricePeriod: Object,
  },
};
</script>

<style lang="scss">
.product-price-group-detail-view {
  .action-button-wrapper {
    display: flex;
    justify-content: flex-end;

    .action-button {
      margin-bottom: 5px;
      width: 140px;
    }
  }

  .dx-checkbox.dx-state-readonly .dx-checkbox-icon {
    border-style: dashed;
    border-color: #ddd;
  }

  .dx-checkbox.dx-state-readonly .dx-checkbox-icon,
  .textbox-readonly {
    background-color: #FAFAFA !important;
  }

  .detail-element-container {
    padding-bottom: 10px;
  }

  .padding-top {
    padding-top: 15px;
  }
}
</style>
